import { FunctionComponent, memo } from 'react';
import { useLinkify } from '../../../../shared';

import classNames from 'classnames';
import classes from './Paragraph.module.scss';

interface ParagraphProps {
  text: string;
  source?: boolean;
}

export const Paragraph: FunctionComponent<ParagraphProps> = memo(({ text, source }) => {
  const { linkify } = useLinkify();

  return (
    <p
      className={classNames(classes['paragraph'], {
        [classes['paragraph--source']]: source,
      })}
      dangerouslySetInnerHTML={{ __html: linkify(text) }}
    ></p>
  );
});
